function sharePost() {
  document.addEventListener("DOMContentLoaded", () => {
    const shareModal = document.getElementById("post-share-modal");
    const closeModalButton = document.getElementById("close-share-modal");
    const copyLinkButton = document.getElementById("copy-link-button");
    const shareButtons = document.querySelectorAll(".post-share-button");
  
    shareButtons.forEach((button) => {
      button.addEventListener("click", () => {
        console.log("Share button clicked");
        shareModal.classList.remove("hidden");
      });
    });
  
    // Close the share modal
    closeModalButton.addEventListener("click", () => {
      shareModal.classList.add("hidden");
    });
  
    // Copy the article link to the clipboard
    copyLinkButton.addEventListener("click", () => {
      const articleUrl = window.location.href; // Get the current page URL
      navigator.clipboard.writeText(articleUrl).then(() => {
        // Change the icon to indicate success
        const icon = copyLinkButton.querySelector("span");
        icon.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.73499 9.17327L8.67633 10.1146L14.32 4.47087L15.2629 5.41368L8.67633 12.0002L4.43366 7.75753L5.37647 6.81474L6.79299 8.23127L7.73499 9.17327ZM7.73613 7.28814L11.0379 3.98633L11.9781 4.92651L8.67633 8.22827L7.73613 7.28814ZM5.85165 11.0582L4.90963 12.0002L0.666992 7.75753L1.6098 6.81474L2.55181 7.7568L2.55102 7.75753L5.85165 11.0582Z" fill="currentColor"/>
        </svg>
        `; // Replace with the checklist icon  (checkbox-multiple-fill.hbs)
        copyLinkButton.classList.add("color-secondary");
        copyLinkButton.classList.remove("color-primary");

        // Reset the icon after 2 seconds
        setTimeout(() => {
          icon.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.6662 4.66671V2.00004C4.6662 1.63185 4.96467 1.33337 5.33287 1.33337H13.9995C14.3677 1.33337 14.6662 1.63185 14.6662 2.00004V10.6667C14.6662 11.0349 14.3677 11.3334 13.9995 11.3334H11.333V13.995C11.333 14.366 11.0337 14.6667 10.6613 14.6667H2.00453C1.63358 14.6667 1.33301 14.3674 1.33301 13.995L1.33485 5.33836C1.33493 4.96742 1.63421 4.66671 2.00651 4.66671H4.6662ZM5.99953 4.66671H10.6615C11.0323 4.66671 11.333 4.96599 11.333 5.33836V10H13.3329V2.66671H5.99953V4.66671Z" fill="currentColor"/>
          </svg>
          `; // Restore the original icon (check-double-fill.hbs)
          copyLinkButton.classList.remove("color-secondary");
          copyLinkButton.classList.add("color-primary");
        }, 2000);
      });
    });
  });
}
